import React from 'react';
import './AccordionPrimary.scss';
import Accordion, { AccordionProps } from './Accordion';
import classNames from 'classnames';

const AccordionPrimary: React.FC<AccordionProps> = props => {
  return (
    <Accordion {...props} classNames={classNames('AccordionPrimary', props.classNames)}>
      {props.children}
    </Accordion>
  );
};

export default AccordionPrimary;
